angular.module('natgeo').controller('SplashSplashScreen', ['$scope', '$element', 'ScreenFactory', 'screenManager', 'container', 'SoundEngine', 
function SplashSplashScreen($scope, element, ScreenFactory, manager, container, SoundEngine)
{
	var screen = ScreenFactory( 'splash_splash', element );
	
	screen.once('introBefore', function()
	{
		anim8.save('splashRobotPrimaryIntro', {
			keyframe: {
				from: {
					translate: 0,
					scale: 1,
					opacity: 0
				},
				to: {
					translate: {x: -60, y: 15},
					scale: 1.25,
					opacity: 1
				}
			},
			units: {
				translate: '%'
			}
		});
		
		anim8.save('splashRobotSecondaryIntro', {
			keyframe: {
				from: {
					translate: 0,
					scale: 1,
					opacity: 0
				},
				to: {
					translate: {x:160, y:110},
					scale: 1.25,
					opacity: 1
				}
			},
			units: {
				translate: '%'
			}
		});
		
		anim8.save('splashRedDotBounce', {
			keyframe: {
				from: {
					translate: 0
				},
				to: {
					translate: {x: 800.0, y: -140.0}
				}
			},
			units: {
				translate: '%'
			}
		});
		
		anim8.save('splashRobotPrimaryOutro', {
			keyframe: {
				from: {
					translate: {x: -60, y: 15},
					scale: 1.25,
					opacity: 1
				},
				to: {
					translate: {x: -120, y: 30},
					scale: 1.5,
					opacity: 0
				}
			},
			units: {
				translate: '%'
			}
		});
	});
	
	// The next screen is the factory screen
	$scope.next = function()
	{
		manager.transition('splash_factory');

		SoundEngine.register();
	};
	
}]);